export default "__VITE_ASSET__jvEnE$jX__"